import React, { useContext, useMemo } from 'react'

import { AstuteContext } from '../../context'

import { Button } from "@UILibrary/Button"
import { Dropdown } from '@UILibrary/Dropdown'
import { Grid } from '@UILibrary/Grid'
import { Pill } from '@UILibrary/Pill'
import { Text } from '@UILibrary/Text'

import { Card, CardContent } from '@components/layout/Card'

import Routes from '@utils/routes';

export const Header = ({
  pendingHoldings,
  openModal,
}) => {
  const {
    state: { client, astuteRequest },
  } = useContext(AstuteContext)

  const refreshText = useMemo(() => {
    if (astuteRequest.can_refresh === false) {
      return `you can request another manual refresh in ${astuteRequest.time_until_next_refresh}`
    }

    return 'you can request another manual refresh'
  })

  return (
    <>
      <Card className='padding-top-level' margin={{ bottom: 'xxl'}}>
        <CardContent>
          <Text bodySmall><strong>{astuteRequest.created_at}</strong></Text>
          <Grid cols="1-a" gap="m">
            <div>
              <Text colour="secondary-main" heading1b>{client.first_names} {client.last_name}'s Astute Report</Text>
            </div>
            <div>
              {pendingHoldings.length > 0 ?
              (<Pill
                color="info"
                shape="round"
                size="medium"
              >
                <Text margin='none' bodySmall>Pending provider responses</Text>
              </Pill>) :
              (<Pill
                color="secondary_two"
                shape="round"
                size="medium"
              >
                <Text margin='none' bodySmall>Completed</Text>
              </Pill>)
              }
            </div>
          </Grid>

          <Grid cols="2-1" margin={{ bottom: 's' }}>
            <Text bodySmall margin='none'>Last refreshed {astuteRequest.last_refreshed_time_ago} ago - {refreshText}</Text>
          </Grid>

          <Grid cols="1-a" gap="xxl">
            <div></div>
            <Grid cols="1-a" gap="xs">
              <Button
                className='button'
                onClick={() => { window.location.href = Routes.downloadAstuteReportPDFPath({ clientId: client.id, astuteRequestId: astuteRequest.id }) }}
                primary
              >
                Download PDF report
              </Button>

              <Dropdown iconOnly>
                {astuteRequest.can_refresh === true && (
                  <Dropdown.Option
                    value={0}
                    label="Refresh report"
                    onClick={() => { window.location.href = Routes.astuteRefreshPath({ clientId: client.id, astuteRequestId: astuteRequest.id }) }}
                  />
                )}
                <Dropdown.Option
                  value={null}
                  label={"Request new report"}
                  onClick={openModal}
                />
              </Dropdown>
            </Grid>
          </Grid>
        </CardContent>
      </Card>
    </>
  )
}
